<script setup>
import { computed, nextTick } from 'vue';
import vClickOutside from '/app/directives/click-outside';
import { useEscapeStack } from '/app/composables/escape-stack';

const props = defineProps({
    modelValue: Boolean,
    disabled: Boolean,
    width: [Number, String]
});

const emit = defineEmits(['update:modelValue', 'change', 'close', 'open']);

const active = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
});

function toggle() {
    if (props.disabled) {
        return;
    }

    active.value = !active.value;
    emit('change', active.value);

    nextTick(() => {
        if (active.value) {
            emit('open');
        } else {
            emit('close');
        }
    });
}

function close() {
    active.value = false;
    emit('close');
}

useEscapeStack(active, () => close());
</script>

<template>
    <div class="tabs-menu relative">
        <div v-click-outside="close" class="tabs-menu__wrapper w-full flex items-end justify-center py-2" :class="{ 'is-active': active }">
            <slot name="activator" as="one-test" :on="{ click: toggle, 'click.outside': toggle }" />
            <div v-show="active" class="tabs-menu__wrapper-content z-20">
                <slot />
            </div>
        </div>
    </div>
</template>
